import { withFormik } from 'formik';
import { resendEmail } from '../../../facades/eagle/user';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withQueryParams from '../../hocs/withQueryParams';
import { replaceRichText } from 'src/common/utils/text-replace';

/* eslint-disable no-console */
const withResendPassword = compose(
  withQueryParams,
  withProps(props => ({
    formDescription: replaceRichText(props.formDescription, {
      email: props.queryParams.email
    }),
    formSubmissionMessage: replaceRichText(props.formSubmissionMessage, {
      email: props.queryParams.email
    })
  })),
  withFormik({
    mapPropsToValues: (props) => ({
      base: '',
      email: props.queryParams.email
    }),
    handleSubmit: (values, actions) => {
      const props = actions.props;
      resendEmail(values)
        .then(() => {
          props.setSubmitted(true);
          setTimeout(() => {
            actions.setSubmitting(false);
            props.setSubmitted(false);
          }, 2000);
        })
        .catch(err => {
          actions.setSubmitting(false);
          const errors = err.details.errors;
          switch (err.status) {
            case 404:
              actions.setFieldError('base', errors[0].detail);
          }
        });
    },
  }),
);
/* eslint-enable no-console */

export default withResendPassword;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/withResendEmail.js